import $ from 'jquery'

window.jQuery = $
window.$ = $

export default function handleFormErrors() {
  const loadingElement = document.querySelector('#form-loading');
  const responseElement = document.querySelector('#form-response-error');
  const overlayElement = document.querySelector('.c-form-overlay');

  if (!loadingElement || !responseElement || !overlayElement) {
    return;
  }
  
  function showLoading() {
    hideTexts();
    loadingElement.classList.remove('u-hide');
    overlayElement.classList.remove('u-hide');
  }

  function hideLoading() {
    loadingElement.classList.add('u-hide');
    overlayElement.classList.add('u-hide');
  }

  function showTexts() {
    document.querySelectorAll('.u-hide-on-response').forEach(el => el.classList.remove('u-hide'));
  }

  function hideTexts() {
    document.querySelectorAll('.u-hide-on-response').forEach(el => el.classList.add('u-hide'));
  }

  function showErrorModal(message) {
    responseElement.querySelector('h2').innerHTML = message;
    hideTexts();
    responseElement.classList.remove('u-hide');
    overlayElement.classList.remove('u-hide');
  }

  function hideErrorModal() {
    showTexts();
    responseElement.classList.add('u-hide');
    overlayElement.classList.add('u-hide');
  }

  responseElement.querySelector('.c-btn-light-bg').addEventListener('click', function(e) {
    e.preventDefault();
    hideErrorModal();
  });

  $(document).on('gform_post_render', function(event, form_id, current_page){
    if (form_id === 7) {

      const formElement = document.getElementById('gform_7');
      if (formElement) {
        formElement.addEventListener('submit', function(e) {
          showLoading();
        });
      }
      hideLoading();
      
      const messageInput = $("#input_7_10");
      if (messageInput.length > 0) {
        showTexts();
      }
      const message = $("#input_7_10").val();
      $("#input_7_10").val('');

      console.log('render, show error', messageInput.length);
      if (messageInput.length > 0 && message !== '') { 
        showErrorModal(message);
      }  
    }
  });

  $(document).on('gform_confirmation_loaded', function(event, form_id){
    console.log('confirmation loaded');
    if (form_id === 7) { 
      hideLoading();
      hideErrorModal();
      hideTexts();
    }
});
}